import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShopProductPurchaseOptionsQuery } from './getShopProductPurchaseOptions';
import { ShopProductPurchaseOptionsVariants } from '../../../types/definitions/vendor/graphql-schema.d';

const useShopProductPurchaseOptions = ({
  skuId,
  skip,
}: {
  skuId: string;
  skip: boolean;
}) => {
  const {
    data: shopProductPurchaseOptionsData,
    loading: shopProductPurchaseOptionsLoading,
    error: shopProductPurchaseOptionsError,
  } = useGetShopProductPurchaseOptionsQuery({
    variables: {
      skuId,
    },
    skip,
    onCompleted: () => {
      recordMark('use_shop_product_purchase_options_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('use_shop_product_purchase_options_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(`useShopProductPurchaseOptions error for sku ID ${skuId}`, {
        skuId,
        error_message: shopProductPurchaseOptionsError,
      });
    },
  });

  return {
    shopProductPurchaseOptionsData:
      (shopProductPurchaseOptionsData?.shopContent?.productDetailsPage
        ?.shopProductPurchaseOptions as ShopProductPurchaseOptionsVariants) ||
      null,
    shopProductPurchaseOptionsLoading,
    shopProductPurchaseOptionsError,
  };
};

export default useShopProductPurchaseOptions;
